import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FileUpload, Image } from '@chakra-ui/react';
import { LISTING_IMAGE_ASPECT_RATIO } from '@client/constants';
import { listingImageUrl } from '@client/utils/imageUtils';
import { useState } from 'react';
import { FaImage } from 'react-icons/fa';
const THUMB_WIDTH = 100;
const DIMMED_OPACITY = 0.5;
const PLACEHOLDER_ICON_SIZE = 20;
export const ImageUploadCell = ({ imageUuid, isInherited, disabled, shopShortId, uploadImage, onUpload, }) => {
    const [isUploading, setIsUploading] = useState(false);
    const isDimmed = isUploading || !!isInherited;
    return (_jsxs(FileUpload.Root, { accept: "image/*", maxFiles: 1, disabled: disabled, onFileChange: async (details) => {
            const file = details.acceptedFiles[0];
            if (!file)
                return;
            setIsUploading(true);
            const uuid = await uploadImage(file);
            setIsUploading(false);
            if (uuid)
                onUpload(uuid);
        }, pr: 2, children: [_jsx(FileUpload.HiddenInput, {}), _jsx(FileUpload.Trigger, { asChild: true, children: _jsx(Box, { as: "button", width: THUMB_WIDTH, aspectRatio: LISTING_IMAGE_ASPECT_RATIO, overflow: "hidden", cursor: "pointer", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", bg: "gray.50", children: imageUuid ? (_jsx(Image, { src: listingImageUrl(shopShortId, imageUuid), width: "100%", aspectRatio: LISTING_IMAGE_ASPECT_RATIO, display: "block", objectFit: "cover", opacity: isDimmed ? DIMMED_OPACITY : 1 })) : (_jsx(FaImage, { color: "gray", size: PLACEHOLDER_ICON_SIZE, opacity: isUploading ? DIMMED_OPACITY : 1 })) }) })] }));
};
